// eslint-disable-next-line @typescript-eslint/no-var-requires
module.exports = require('./Primer').default;
